(ns app.strive-forms.events
  (:require [ajax.core :as ajax]
            [app.endpoints :refer [cache-form fetch-form-messages-endpoint
                                   fetch-secured-hidden-fields get-form-icon
                                   get-ip-address get-strive-forms-fields submit-form]]
            [app.strive-forms.logic-jumps-logic :refer [check-logic-flow
                                                        create-form-fields]]
            [app.strive-forms.subs :as subs]
            [clojure.walk]
            [day8.re-frame.http-fx]
            [day8.re-frame.tracing :refer [fn-traced]]
            [re-frame.core :as re-frame :refer [reg-event-db reg-event-fx]]
            [re-posh.core :as re-posh]
            [re-posh.core :refer [dispatch reg-event-ds]]))

(reg-event-ds
 ::add-form-icon
 (fn-traced [_ [_ val]]
            [[:db/add 15 :form-filling/icon val]]))

(reg-event-db
 :get-form-icon-success
 (fn [ds [_ form-icon]]
   (dispatch [::add-form-icon (:profile_image_url (first form-icon))])))

(reg-event-fx
 ::get-form-field
 (fn [{:keys [ds]} [_ {:keys [form-id query-params parsed-query-params]}]]
   {:http-xhrio {:method          :get
                 :uri    (get-strive-forms-fields form-id query-params)
                 :headers  {"content-type"  "application/json"
                            "Cache-Control"  "no-cache"}
                 :mode :cors
                 :format          (ajax/json-request-format)
                 :response-format (ajax/json-response-format {:keywords? true})
                 :Referrer-Policy "http://localhost:8081"
                 :on-success      [:get-form-data-success parsed-query-params]
                 :on-failure      [:get-form-data-error]}}))

(reg-event-fx
 ::fetch-secured-hidden-fields
 (fn [{:keys [ds]} [_ {:keys [secured-fields-key hidden-fields]}]]
   {:http-xhrio {:method          :get
                 :uri    (fetch-secured-hidden-fields secured-fields-key)
                 :headers  {"content-type"  "application/json"
                            "Cache-Control"  "no-cache"}
                 :mode :cors
                 :format          (ajax/json-request-format)
                 :response-format (ajax/json-response-format {:keywords? true})
                 :Referrer-Policy "http://localhost:8081"
                 :on-success      [:get-secured-hidden-fields-success hidden-fields]
                 :on-failure      [:endpoint-request-error]}}))

(reg-event-fx
 ::get-ip-address
 (fn [{:keys [_]} [_ _]]
   {:http-xhrio {:method          :get
                 :uri             get-ip-address
                 :headers {"content-type" "application/json"}
                 :mode :cors
                 :format          (ajax/json-request-format)
                 :response-format (ajax/json-response-format {:keywords? true})
                 :Referrer-Policy "http://localhost:8280"
                 :on-success      [:get-ip-address-success]
                 :on-failure      [:endpoint-request-error]}}))

(defn get-submit-data [input-data display-fields include-all-paths?]
  (if include-all-paths?
    input-data
    (into {} (map  (fn [value]
                     (when-not (= (:type value) "thank_you_screen")
                       {(:id value)
                        (clj->js (get input-data (keyword (:id value))))}))
                   display-fields))))

(reg-event-fx
 ::submit-form
 (fn [{:keys [_]} [_ {:keys [input-data display-fields include-all-paths? form-id is-test is-sms landed-at is-mobile selected-language hidden-fields response-id send-emails auto-submitted]}]]
   (let [submit-data (get-submit-data input-data display-fields include-all-paths?)]
     (dispatch [::submit-form-api {:submit-form-body {:hidden_fields hidden-fields
                                                      :input_data submit-data
                                                      :auto_submited auto-submitted
                                                      :is_mobile is-mobile
                                                      :is_sms is-sms
                                                      :is_test is-test
                                                      :landed_at landed-at
                                                      :language selected-language
                                                      :response_id response-id
                                                      :send_emails send-emails}
                                   :form-id form-id}]))))

(reg-event-fx
 ::submit-form-api
 (fn [{:keys [ds]} [_ {:keys [submit-form-body form-id]}]]
   {:http-xhrio {:method          :post
                 :uri           (submit-form form-id)
                 :headers  {"content-type"  "application/json"
                            "Cache-Control"  "no-cache"}
                 :body (.stringify js/JSON (clj->js submit-form-body))
                 :format          (ajax/json-request-format)
                 :response-format (ajax/json-response-format {:keywords? true})
                 :Referrer-Policy "http://localhost:8080"
                 :on-success      [:submit-form-success]
                 :on-failure      [:endpoint-request-error]}}))

(reg-event-fx
 ::get-form-icon
 (fn [{:keys [ds]} [_ {:keys [token form-id]}]]
   {:http-xhrio {:method          :get
                 :uri           (get-form-icon form-id)
                 :headers  {"Authorization"  (str "Bearer " token)
                            "Cache-Control"  "no-cache"}
                 :format          (ajax/json-request-format)
                 :response-format (ajax/json-response-format {:keywords? true})
                 :Referrer-Policy "http://localhost:8081"
                 :on-success      [:get-form-icon-success]
                 :on-failure      [:endpoint-request-error]}}))

(reg-event-fx
 ::cache-form-data
 (fn [{:keys [ds]} [_ {:keys [cache-form-body form-id]}]]
   {:http-xhrio {:method          :post
                 :uri           (cache-form form-id)
                 :headers  {"content-type"  "application/json"
                            "Cache-Control"  "no-cache"}
                 :body (.stringify js/JSON (clj->js cache-form-body))
                 :format          (ajax/json-request-format)
                 :response-format (ajax/json-response-format {:keywords? true})
                 :Referrer-Policy "http://localhost:8080"
                 :on-success      [:submit-form-success]
                 :on-failure      [:endpoint-request-error]}}))

(reg-event-fx
 ::fetch-form-messages
 (fn [{:keys [ds]} [_ {:keys [form-id selected-language]}]]
   {:http-xhrio {:method          :get
                 :uri    (fetch-form-messages-endpoint form-id selected-language)
                 :headers  {"content-type"  "application/json"
                            "Cache-Control"  "no-cache"}
                 :mode :cors
                 :format          (ajax/json-request-format)
                 :response-format (ajax/json-response-format {:keywords? true})
                 :Referrer-Policy "http://localhost:8081"
                 :on-success      [:form-messages-success]
                 :on-failure      [:endpoint-request-error]}}))

(reg-event-fx
 ::get-form-data
 (fn [{:keys [ds]} [_ {:keys [form-id query-params parsed-query-params token]}]]
   (dispatch [::add-form-error-message ""])
   (dispatch [::get-form-field {:form-id form-id :query-params query-params :parsed-query-params parsed-query-params}])
   (dispatch [::get-ip-address ""])
   (dispatch [::get-form-icon {:form-id form-id :token token}])
   (if (nil? (:secured_fields_key parsed-query-params))
     (dispatch [::add-hidden-fields parsed-query-params])
     (dispatch [::fetch-secured-hidden-fields {:secured-fields-key (:secured_fields_key parsed-query-params)
                                               :hidden-fields parsed-query-params}]))))

(defn _generate-children-list [form-fields logic-flows input-data]
  (let [form-data  @(re-posh/subscribe [::subs/form-data])
        jump-to-field-id (when-not (and (nil? logic-flows) (nil? (:hidden_fields logic-flows)))
                           (check-logic-flow (:hidden_fields logic-flows) nil (:form-filling/hidden-fields form-data) nil))]
    (if (and (nil? logic-flows) (nil? (:hidden_fields logic-flows)))
      (dispatch [::add-display-fields form-fields])
      (dispatch [::add-display-fields (create-form-fields jump-to-field-id form-fields logic-flows form-data input-data)]))))

(reg-event-db
 :get-form-data-success
 (fn [ds [_  parsed-query-params {:keys [content]}]]
   (let [selected-language (if (some? (:language parsed-query-params))
                             (:language parsed-query-params)
                             (if (some? (:default_language (:form content)))
                               (:default_language (:form content))
                               "en"))]
     (when (and (some? (:closed content)) (:closed content))
       (dispatch [::add-form-error-message
                  "This form is not available anymore!"]))
     (when (and (some? (:already_answered content)) (:already_answered content))
       (dispatch [::add-form-error-message
                  "You already answered this form!"]))
     (when (nil? (:form content))
       (dispatch [::add-form-error-message
                  "Incorrect form url"]))
     (when-not (nil? (:prefilled_answer parsed-query-params))
       (dispatch [::add-prefilled-answer (:prefilled_answer parsed-query-params)]))
     (dispatch [::add-form-data (:form content)])
     (dispatch [::add-form-fields (:fields content)])
     (dispatch [::add-form-language selected-language])
     (dispatch [::add-allowed-language (:allowed_languages (:form content))])
     (dispatch [::fetch-form-messages {:form-id (:form_id parsed-query-params) :selected-language selected-language}])
     (when-not (nil? (:logic_flow (:form content)))
       (dispatch [::add-logic-Flow (:logic_flow (:form content))]))
     (dispatch [::add-input-fields-data
                (into {} (map
                          (fn [value]
                            (when-not (= "thank_you_screen" (:type value)) {(keyword (:id value))
                                                                            {:value nil
                                                                             :field_name (:field_name value)
                                                                             :field_html (:field_name_html value)
                                                                             :input_type (:type value)
                                                                             :group_id (:group_id value)
                                                                             :group_instance_id (:group_instance_id value)
                                                                             :filled_at nil
                                                                             :field_id (:id value)
                                                                             :field_additional_settings (:additional_settings value)
                                                                             :additional_text nil
                                                                             :item_order (:item_order value)
                                                                             :page_title (:page_title value)
                                                                             :is-required (:is_required value)}}))
                          (:fields content)))])
     (_generate-children-list (:fields content) (:logic_flow (:form content)) nil))))

(reg-event-fx
 ::regenerate-display-fields
 (fn [{:keys [_]} [_ {:keys [form-fields logic-flow input-data]}]] 
   (_generate-children-list form-fields logic-flow input-data)))

(reg-event-db
 :get-form-data-error
 (fn [ds [_  _]]
   (dispatch [::add-form-error-message
              "Incorrect form url"])))

(reg-event-db
 :form-messages-success
 (fn [ds [_ {:keys [content]}]]
   (dispatch [::add-form-messages (clojure.walk/keywordize-keys (into {} (mapv  (fn [val] [(:key val) (:value val)]) content)))])))

(reg-event-ds
 ::add-form-data
 (fn-traced [_ [_ val]]
            [[:db/add 15 :form-filling/form-data val]]))

(reg-event-ds
 ::add-form-fields
 (fn-traced [_ [_ val]]
            [[:db/add 15 :form-filling/form-fields val]]))

(reg-event-ds
 ::add-prefilled-answer
 (fn-traced [_ [_ val]]
            [[:db/add 15 :form-filling/prefilled-answer val]]))

(reg-event-db
 :get-secured-hidden-fields-success
 (fn [ds [_ hidden-fields {:keys [content]}]]
   (dispatch [::add-hidden-fields (merge hidden-fields content)])))

(reg-event-db
 :get-ip-address-success
 (fn [ds [_ client-address-data]]
   (dispatch [::add-country-code (:country_code client-address-data)])))

(reg-event-ds
 ::add-country-code
 (fn-traced [_ [_ val]]
            [[:db/add 15 :form-filling/country-code val]]))

(reg-event-ds
 ::add-hidden-fields
 (fn-traced [_ [_ val]]
            [[:db/add 15 :form-filling/hidden-fields val]]))

(reg-event-fx
 ::update-selected-form-language
 (fn [{:keys [_]} [_ val]]
   (dispatch [::fetch-form-messages {:form-id (:form-id val) :selected-language (:value val)}])
   (dispatch [::add-form-language (:value val)])))

(reg-event-ds
 ::add-form-language
 (fn-traced [_ [_ val]]
            [[:db/add 15 :form-filling/form-language val]
             [:db/add 15 :form-filling/language-direction (if (or (= "ar" val) (= "he" val)) "RTL" "LTR")]]))

(reg-event-ds
 ::add-allowed-language
 (fn-traced [_ [_ val]]
            [[:db/add 15 :form-filling/allowed-languages val]]))

(reg-event-ds
 ::add-form-messages
 (fn-traced [_ [_ val]]
            [[:db/add 15 :form-filling/form-messages val]]))

(reg-event-ds
 ::add-form-error-message
 (fn-traced [_ [_ val]]
            [[:db/add 15 :form-filling/error-form-messages val]]))

(reg-event-ds
 ::add-logic-Flow
 (fn-traced [_ [_ val]]
            [[:db/add 15 :form-filling/logic-flow val]]))

(reg-event-ds
 ::add-display-fields
 (fn-traced [_ [_ val]]
            [[:db/add 15 :form-filling/display-fields val]]))

(reg-event-ds
 ::add-input-fields-data
 (fn-traced [_ [_ val]]
            [[:db/add 15 :form-filling/input-data val]]))

(reg-event-fx
 ::update-input-local
 (fn [{:keys [_]} [_ {:keys [input-data key value]}]]
   (dispatch [::add-input-fields-data (update input-data key #(assoc % :value value))])))

(reg-event-fx
 ::update-input-data-array-local
 (fn [{:keys [_]} [_ {:keys [input-data]}]] 
   (dispatch [::add-input-fields-data input-data])))